import apiService from "./api.services";
import { AuthResponse } from "../reducers/auth/authTypes";
import { TREDOT_BACKEND_URL, API_PREFIX } from "./api.services";
import axios from "axios";
import { saveToStorage } from "../reducers/auth/authSlice";

interface UploadResponse {
  imageUrl: string; // or whatever your backend returns
  message: string;
}

// Use the BACKEND_URL from the ApiService
export const BACKEND_URL = `${TREDOT_BACKEND_URL}${API_PREFIX}`;

export const validateEmail = (email: string): boolean => {
  return apiService.validateEmail(email);
};

// Auth methods
export const loginUser = async (credentials: {
  email: string;
  password: string;
}): Promise<AuthResponse> => {
  try {
    const response = await apiService.post<AuthResponse>(
      "/auth/login",
      credentials
    );

    if (response.user) {
      const accessToken =
        response.user.accessToken || response.user?.accessToken;
      const refreshToken = response.user.refreshToken;
      if (accessToken && refreshToken) {
        await apiService.authService.setTokens({
          accessToken,
          refreshToken,
        }, response.user);
      }
    }
    return response;
  } catch (error) {
    apiService.handleApiError(error);
    throw error;
  }
};



export const findStudent = async (
  email: string
): Promise<any> => {
  try {
    const response = await axios.post<any>(
      `${BACKEND_URL}/auth/get-student`,
      { email },
      // {
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      // }
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const registerTutor = async (
  userData: FormData
): Promise<AuthResponse> => {
  try {
    const response = await apiService.post<AuthResponse>(
      "/auth/register-tutor",
      userData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    // Independent tutors pending admin approval have no tokens — skip storage
    if (response.user?.accessToken && response.user?.refreshToken) {
      await apiService.authService.setTokens({
        accessToken: response.user.accessToken,
        refreshToken: response.user.refreshToken,
      }, response.user);

      saveToStorage({
        user: response.user,
        tredot_accessToken: response.user.accessToken,
        tredot_refreshToken: response.user.refreshToken,
      });

      axios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${response.user.accessToken}`;
    }

    return response;
  } catch (error) {
    // The error toast is already handled by handleApiError in the interceptor
    // Just re-throw so calling code knows it failed
    throw error;
  }
};


export const registerTutorByOrganization = async (
  userData: FormData
): Promise<AuthResponse> => {
  try {
    const response = await apiService.post<any>(
      "/auth/register-tutor/organization",
      userData,
      // {
      //   headers: {
      //     "Content-Type": "multipart/form-data",
      //   },
      // }
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const registerStudent = async (userData: any): Promise<AuthResponse> => {
  try {
    const response = await apiService.post<AuthResponse>(
      "/auth/register-student",
      userData
    );
    return response;
  } catch (error) {
    apiService.handleApiError(error);
    throw error;
  }
};

export const verifyEmailToken = async (token: string,): Promise<AuthResponse> => {
  try {
    const response = await apiService.get<AuthResponse>(
      `/auth/verify-email?token=${token}`
    );
    return response;
  } catch (error) {
    console.error("error from registration service", error);
    apiService.handleApiError(error);
    throw error;
  }
};

export const verifyOrganizatonEmailToken = async (token: string, name: string, email: string): Promise<any> => {
  try {
    const response = await apiService.get<AuthResponse>(
      `/organizations/verify-email?token=${token}`,
      { params: { organizationName: name, email: email } }
    );
    return response;
  } catch (error) {
    apiService.handleApiError(error);
    throw error;
  }
};
export const resendVerificationEmail = async (email: string, userType: string): Promise<AuthResponse> => {
  try {
    const response = await apiService.post<AuthResponse>(
      `/auth/resend-verification-email`,
      { email, userType }
    );
    return response;
  } catch (error) {
    apiService.handleApiError(error);
    throw error;
  }
};

export const resendOrganizationVerificationEmail = async (email: string): Promise<AuthResponse> => {
  try {
    const response = await apiService.post<AuthResponse>(
      `/organizations/resend-verification-email`,
      { email }
    );
    return response;
  } catch (error) {
    apiService.handleApiError(error);
    throw error;
  }
};

export const registerStudentByOrganization = async (userData: any): Promise<AuthResponse> => {
  try {
    const response = await apiService.post<AuthResponse>(
      "/auth/register-student/organization",
      userData
    );
    return response;
  } catch (error) {
    apiService.handleApiError(error);
    throw error;
  }
};




export const organizationLogin = async (
  credentials: any
): Promise<AuthResponse> => {
  try {
    const response = await apiService.post<AuthResponse>(
      "/auth/organization-login",
      credentials
    );
    if (response.user) {
      const accessToken =
        response.user.accessToken || response.user?.accessToken;
      const refreshToken = response.user.refreshToken;
      if (accessToken && refreshToken) {
        await apiService.authService.setTokens({
          accessToken,
          refreshToken,
        }, response.user);
      }
    }
    return response;
  } catch (error) {
    apiService.handleApiError(error);
    throw error;
  }
};


export const uploadTutorProfilePicture = async (
  data: FormData
): Promise<any> => {
  try {
    const response = await apiService.post<any>("/auth/upload-tutor-profile-picture", data, {
      headers: {
        // DO NOT manually set Content-Type to multipart/form-data
        // Let Axios and the browser handle the boundary automatically
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    apiService.handleApiError(error);
    throw error;
  }
};

export const uploadStudentProfilePicture = async (
  data: FormData
): Promise<any> => {
  try {
    const response = await apiService.post<any>("/auth/upload-student-profile-picture", data, {
      headers: {
        // DO NOT manually set Content-Type to multipart/form-data
        // Let Axios and the browser handle the boundary automatically
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    apiService.handleApiError(error);
    throw error;
  }
};


export const handleFreeCourseEnroll = async (
  courseId: any
): Promise<any> => {
  try {
    const response = await apiService.post<any>(
      "/courses/enroll/free",
      { courseId }
    );
    return response;
  } catch (error) {
    apiService.handleApiError(error);
    throw error;
  }
};
